/* esm.sh - applesauce-core@5.2.0/helpers/factory */
export * from "/*applesauce-core@5.2.0/esnext/helpers/factory.mjs";
